import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

import {
  EntityPickerRenderedString,
  EntityPickerRenderedStringSchema,
} from './EntityPickerRenderedStringExtension';

export const EntityPickerRenderedStringExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    component: EntityPickerRenderedString,
    name: 'EntityPickerRenderedString',
    schema: EntityPickerRenderedStringSchema,
  }),
);
